var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRatingStar = function SvgRatingStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1c.503 0 .962.288 1.182.742l4.853 10.027 10.845 1.617a1.319 1.319 0 0 1 .731 2.238l-7.86 7.806 1.857 11.035c.083.495-.122.994-.53 1.287a1.31 1.31 0 0 1-1.386.092L19 30.646l-9.692 5.198c-.442.237-.98.202-1.387-.092a1.32 1.32 0 0 1-.529-1.288L9.248 23.43 1.39 15.623a1.319 1.319 0 0 1 .732-2.237l10.844-1.617 4.853-10.027C18.038 1.288 18.497 1 19 1",
    clipRule: "evenodd"
  })));
};
export default SvgRatingStar;